import { useMaybeAssignCategoryTreeExperiment } from "@faire/retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { IRecordCategoryNodesVisibilityRequest } from "@faire/web-api--source/indigofair/category/IRecordCategoryNodesVisibilityRequest";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import { useCallback } from "react";
export var useMaybeAssignCategoryTreeExperimentForFilterSection = function() {
    var maybeAssignCategoryTreeExperiment = useMaybeAssignCategoryTreeExperiment();
    return useCallback(function(section, pathIdentifiers) {
        if (section.field_name === IFilterSection.FieldName.CATEGORY) {
            maybeAssignCategoryTreeExperiment(function() {
                return pathIdentifiers;
            }, IRecordCategoryNodesVisibilityRequest.Source.WEB_SEARCH_RESULTS_CATEGORY_FILTER);
        }
    }, [
        maybeAssignCategoryTreeExperiment
    ]);
};
